<template>
	<div class="user">
		<basic-container>
			<el-row :span="24">
				<el-col :md="24" :sm="24" :xs="24" class="user__main">
					<avue-crud
						ref="crud"
						v-model="form"
						:before-open="onHandleBeforeOpen"
						:data="list"
						:option="option"
						:page.sync="page"
						:table-loading="listLoading"
						@on-load="getList"
						@search-change="searchChange"
						@refresh-change="refreshChange"
						@size-change="sizeChange"
						@current-change="currentChange"
						@row-update="update"
						@row-save="create">
						<template slot="menuLeft">
							<el-radio-group
								v-model="queryType"
								@change="
									getList({
										parentId: 0,
										current: 1,
										size: 20,
									})
								">
								<el-radio-button :label="1">正常</el-radio-button>
								<el-radio-button :label="2">待审核渠道</el-radio-button>
							</el-radio-group>
							<el-button
								style="margin-left: 20px"
								v-if="team_place_add"
								icon="el-icon-plus"
								size="mini"
								type="primary"
								@click="onAddChannel">
								新增渠道
							</el-button>
							<el-button
								style="margin-left: 10px"
								v-if="team_place_edit"
								icon="el-icon-document-copy"
								size="mini"
								type="primary"
								@click="openBatchUpdateFollowImport">
								批量更新业务跟进人
							</el-button>
						</template>
						<template slot="contactPerson" slot-scope="scope">
							<span>{{ scope.row.contactPerson }}</span>
						</template>
						<template slot="contactPersonMobile" slot-scope="scope">
							<span>{{ scope.row.contactPersonMobile }}</span>
						</template>
						<template slot="name" slot-scope="scope">
							<span>{{ scope.row.name }}</span>
						</template>
						<template slot="remark" slot-scope="scope">
							<span>{{ scope.row.remark }}</span>
						</template>
						<template slot="createAt" slot-scope="scope">
							<span>{{ scope.row.createAt }}</span>
						</template>

						<template slot="menuBefore" slot-scope="{row, index}">
							<div class="u-row-center u-flex-wrap">
								<el-button
									v-if="team_place_edit"
									icon="el-icon-edit"
									type="text"
									@click="handleUpdate(row, index, 'view')">
									查看
								</el-button>
								<el-button
									v-if="team_place_edit"
									class="u-m-r-20"
									icon="el-icon-edit"
									type="text"
									@click="handleUpdate(row, index, 'edit')">
									编辑
								</el-button>
								<!-- <el-button icon="el-icon-notebook-2" type="text" @click="showChannelLog(row)">日志</el-button> -->

								<!-- <div style="width: 100%; display: flex; flex-wrap: wrap; justify-content: center">
									

									<div>
										<el-button
											icon="el-icon-warning-outline"
											type="text"
											v-if="row.status != 4"
											@click="handleStatus(row, index)">
											{{ row.status === 1 ? '停用' : '启用' }}
										</el-button>
										<el-button v-if="team_place_del" icon="el-icon-delete" type="text" @click="deletes(row, index)">
											删除
										</el-button>
									</div>
								</div> -->
							</div>
						</template>

						<!-- <template slot="menu" slot-scope="{row, index}"></template> -->
						<template slot-scope="{row}" slot="menuBtn">
							<div class="u-row-center u-flex-col u-column-center" style="padding: 0 20px">
								<el-button icon="el-icon-notebook-2" type="text" @click="showChannelLog(row)">日志</el-button>
								<span></span>
								<el-button
									icon="el-icon-warning-outline"
									type="text"
									v-if="row.status != 4"
									@click="handleStatus(row, index)">
									{{ row.status === 1 ? '停用' : '启用' }}
								</el-button>
								<span></span>
								<el-button v-if="team_place_del" icon="el-icon-delete" type="text" @click="deletes(row, index)">
									删除
								</el-button>
							</div>
						</template>
					</avue-crud>
				</el-col>
			</el-row>
		</basic-container>

		<!-- 渠道日志模态框 -->
		<el-dialog
			:title="currentChannel.name + '日志'"
			:visible.sync="logDialogVisible"
			width="80%"
			:before-close="handleLogClose">
			<channel-log ref="channelLogRef" v-if="logDialogVisible" :channelId="currentChannel.id"></channel-log>
		</el-dialog>

		<!-- 批量更新业务跟进人导入模态框 -->
		<el-dialog :visible.sync="batchUpdateFollowModal" append-to-body title="批量更新业务跟进人" width="35%">
			<div class="import-main">
				<el-steps :active="batchUpdateFollowStep" finish-status="success">
					<el-step title="上传文件"></el-step>
					<el-step title="处理结果"></el-step>
				</el-steps>
				<div v-if="batchUpdateFollowStep == 1" class="import-content">
					<el-upload
						:before-upload="beforeUploadFollow"
						:file-list="followFileList"
						:limit="1"
						:on-remove="handleFollowRemove"
						accept=".xlsx"
						action=""
						drag
						multiple>
						<i class="el-icon-upload"></i>
						<div class="upload-import-text-main">
							<span>点击上传或拖拽文件到这里进行上传</span>
						</div>
					</el-upload>
				</div>
				<div v-if="batchUpdateFollowStep == 2" class="import-content">
					<el-result icon="success" subTitle="导入完成!">
						<template slot="title">
							<div class="import-result-title">导入结果</div>
						</template>
						<template slot="extra">
							<div class="import-result-detail">
								<div class="result-item success">
									<span class="result-label">成功：</span>
									<span class="result-value">{{ batchUpdateFollowResult.successCount || 0 }}条</span>
								</div>
								<div class="result-item" v-if="batchUpdateFollowResult.failCount > 0">
									<span class="result-label">失败：</span>
									<span class="result-value error">{{ batchUpdateFollowResult.failCount || 0 }}条</span>
								</div>
								<div class="result-item">
									<span class="result-label">总计：</span>
									<span class="result-value">{{ batchUpdateFollowResult.totalRows || 0 }}条</span>
								</div>

								<div
									v-if="batchUpdateFollowResult.errorMessages && batchUpdateFollowResult.errorMessages.length > 0"
									class="error-messages">
									<div class="error-title">错误信息：</div>
									<div class="error-list">
										<div
											v-for="(error, index) in batchUpdateFollowResult.errorMessages"
											:key="index"
											class="error-item">
											{{ error }}
										</div>
									</div>
								</div>
							</div>
						</template>
					</el-result>
				</div>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="downloadFollowTemplate">下载模板</el-button>
				<el-button @click="batchUpdateFollowModal = false">
					{{ batchUpdateFollowStep == 1 ? '取消' : '关闭' }}
				</el-button>
				<el-button
					v-if="batchUpdateFollowConfirmShow"
					:disabled="followFileList.length == 0"
					:loading="batchUpdateFollowLoading"
					type="primary"
					@click="confirmBatchUpdateFollow">
					{{ batchUpdateFollowStep == 1 ? '导入' : '下载未成功数据' }}
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	addObj,
	delObj,
	fetchPlaceList,
	putObj,
	searchCustomerClue,
	customerSourceDic,
	batchUpdateFollowImport,
} from '@/api/team/place'
import {mapGetters} from 'vuex'
import channelLog from './channelLog.vue'
import {dicSettleType} from '@/const/dic/settle'

export default {
	name: 'TeamPlace',
	components: {
		channelLog,
	},
	data() {
		return {
			queryType: 1, // 1.正常 2.待审核渠道
			searchForm: {},
			treeOption: {
				nodeKey: 'id',
				addBtn: false,
				menu: false,
				props: {
					label: 'name',
					value: 'id',
				},
			},
			treeData: [],
			option: {
				card: true,
				border: true,
				stripe: true,
				menuAlign: 'center',
				searchMenuSpan: 24,
				searchMenuPosition: 'right',
				searchLabelWidth: 130,
				editBtn: false,
				delBtn: false,
				addBtn: false,
				align: 'center',

				menuType: 'menu',
				menuBtnTitle: '更多操作',
				column: [
					{
						fixed: true,
						label: '渠道ID',
						prop: 'id',
					},
					{
						fixed: true,
						label: '渠道名',
						prop: 'name',
						search: true,
					},
					{
						fixed: true,
						label: '渠道状态',
						type: 'radio',
						prop: 'accountType',
						search: true,
						dicData: [
							{
								label: '正式账户',
								value: 1,
							},
							{
								label: '体验账户',
								value: 2,
							},
						],
					},
					{
						fixed: true,
						label: '注册手机',
						width: 95,
						prop: 'loginMobile',
						search: true,
					},
					{
						fixed: true,
						label: '联系人',
						prop: 'contactPerson',
						search: true,
						span: 12,
					},
					{
						label: '联系手机',
						width: 95,
						prop: 'contactPersonMobile',
						value: '',
						span: 12,
					},
					{
						label: '微信号',
						prop: 'wechatId',
						search: true,
						span: 12,
					},
					{
						label: '渠道属性',
						prop: 'channelAttr',
						type: 'select',
						search: true,
						span: 12,
						dicUrl: `/admin/dict/type/channel_attr`,
					},
					{
						label: '客户来源方式',
						width: 120,
						prop: 'customerSourceType',
						type: 'select',
						dicData: [
							{
								label: '手动选择',
								value: 'HAND',
							},
							{
								label: '线索关联',
								value: 'CLUE',
							},
						],
						search: true,
						span: 12,
						dataType: 'string',
					},
					{
						label: '客户来源',
						prop: 'customerSource',
						hide: true,
						showColumn: false,
						props: {
							label: 'originSourceName',
							value: 'originSource',
						},
						filterable: true,
						type: 'select',
						search: true,
						span: 12,
					},
					{
						label: '客户来源一级',
						width: 120,
						prop: 'customerSourceStr1',
						span: 12,
					},
					{
						label: '客户来源二级',
						width: 120,
						prop: 'customerSourceStr2',
						span: 12,
					},
					//  {
					//   label: '获客方式',
					//   prop: 'channelFrom',
					//   type: 'select',
					//   search: true,
					//   span: 12,
					//   dicUrl: `/admin/dict/type/channel_from`,
					// },
					// {
					//   label: '获客来源',
					//   prop: 'channelFromWay',
					//   type: 'select',
					//   search: true,
					//   span: 12,
					//   dicUrl: '/admin/dict/type/channel_from_way',
					// },

					// {
					//   label: '渠道地区',
					//   prop: 'cityCode',
					//   type: 'cascader',
					//   search: true,
					//   span: 12,
					//   props: {
					//     label: 'areaName',
					//     value: 'areaCode'
					//   },
					//   dicUrl: `/dist/area/list/2`,
					//   emitPath: false
					// }, {
					//   label: '业务区域列表',
					//   prop: 'businessAreas',
					//   type: 'select',
					//   multiple: true,
					//   search: true,
					//   props: {
					//     label: 'areaName',
					//     value: 'areaCode'
					//   },
					//   dicData: [],
					//   filterable: true,
					//   // dicUrl: `/dist/area/list/1`,
					//   dataType: 'string'
					// },
					{
						label: '群名称',
						prop: 'weworkGroupName',
						width: 200,
						formatter: ({weworkGroupName = ''}) => {
							return weworkGroupName === '' ? '--' : weworkGroupName
						},
					},
					{
						label: '渠道开设联系人',
						prop: 'contactId',
						type: 'select',
						search: true,
						filterable: true,
						props: {
							label: 'name',
							value: 'id',
						},
						dicUrl: '/dist/distChannel/listContact',
					},
					{
						label: '业务跟进人',
						prop: 'followId',
						type: 'select',
						filterable: true,
						props: {
							label: 'name',
							value: 'id',
						},
						rules: [
							{
								required: true,
								message: '请选择业务跟进人',
								trigger: ['blur', 'change'],
							},
						],
						dicUrl: '/dist/distChannel/listContact',
					},
					//结算方式
					{
						label: '结算方式',
						prop: 'settleType',
						type: 'select',
						search: true,
						span: 12,
						dicData: dicSettleType,
					},

					// {
					//   label: '结算人',
					//   prop: 'settleUserName',
					//   search: true,
					//   span: 12,
					//   rules: [
					//   {
					//     min: 2,
					//     max: 10,
					//     message: '长度在 2 到 10 个字符',
					//     trigger: 'blur'
					//   }]
					// },
					// {
					//   label: '身份证号',
					//   prop: 'settleUserIdNo',
					//   value: '',
					//   span: 12,
					//   rules: [{
					//     validator: rule.validatorIdNo,
					//     trigger: 'blur'
					//   }]
					// },
					// {
					//   label: '开户行',
					//   prop: 'settleBankName',
					//   span: 12,
					//   rules: [
					//   {
					//     min: 4,
					//     max: 20,
					//     message: '长度在 4 到 20 个字符',
					//     trigger: 'blur'
					//   }]
					// },
					// {
					//   label: '银行卡号',
					//   prop: 'settleBankCardNo',
					//   value: '',
					//   span: 12,
					//   rules: []
					// },
					//渠道新增字段：Integer active 激活状态，1是0否 全部 -1
					{
						label: '激活状态',
						prop: 'active',
						type: 'select',
						search: true,
						dicData: [
							{
								label: '全部',
								value: '',
							},
							{
								label: '是',
								value: 1,
							},
							{
								label: '否',
								value: 0,
							},
						],
					},
					{
						label: '状态',
						prop: 'status',
						type: 'switch',
						search: true,
						slot: false,
						value: 1,
						span: 12,
						dicData: [
							{
								label: '停用',
								value: 0,
							},
							{
								label: '启用',
								value: 1,
							},
							{
								label: '待审核',
								value: 4,
							},
						],
					},
					{
						label: '投保状态',
						prop: 'insureAuthority',
						type: 'select',
						search: true,
						dicData: [
							{
								label: '全部可用',
								value: 'ALL',
							},
							{
								label: '禁止新保(可替换与新增)',
								value: 'OLD',
							},
							{
								label: '禁止新保和新增(可替换)',
								value: 'REPLACE',
							},
						],
					},
					{
						label: '协议是否过期',
						width: 120,
						prop: 'protocolExpire',
						type: 'select',
						dicData: [
							{
								label: '存续中',
								value: '0',
							},
							{
								label: '已终止',
								value: '1',
							},
						],
						search: true,
						dataType: 'string',
					},
					{
						label: '到期时间',
						prop: 'insureAuthorityExpireTime',
						formatter: ({insureAuthorityExpireTime = '', insureAuthority = ''}) => {
							return insureAuthorityExpireTime !== '' && insureAuthority !== 'ALL' ? insureAuthorityExpireTime : '--'
						},
					},
					{
						label: '是否过期',
						prop: 'insureAuthorityExpire',
						type: 'select',
						hide: true,
						search: true,
						dicData: [
							{
								label: '是',
								value: true,
							},
							{
								label: '否',
								value: false,
							},
						],
					},
					{
						label: '可用产品',
						prop: 'insureTypes',
						//内容长则隐藏
						overHidden: true,
						dicData: [],
						width: 300,
						html: true,
					},
					{
						label: '理赔跟进方式',
						prop: 'claimsWay',
						width: 200,
						type: 'select',
						dicData: [
							{
								label: '客户自行理赔',
								value: 'CUSTOMERS_CLAIMS',
							},
							{
								label: '下级业务员各自跟进',
								value: 'SALESMAN_FOLLOW',
							},
							{
								label: '渠道统一跟进',
								value: 'CHANNEL_FOLLOW',
							},
						],
					},
					{
						label: '备注',
						prop: 'remark',
						search: true,
						width: 160,
					},
					{
						width: 120,
						label: '创建时间',
						prop: 'createdAt',
						type: 'datetime',
						format: 'yyyy-MM-dd HH:mm',
						valueFormat: 'yyyy-MM-dd HH:mm:ss',
					},
					{
						label: '创建时间',
						prop: 'createdAts',
						type: 'datetime',
						hide: true,
						searchSpan: 12,
						searchRange: true,
						search: true,
						format: 'yyyy-MM-dd HH:mm',
						valueFormat: 'yyyy-MM-dd HH:mm:ss',
					},
					{
						width: 120,
						label: '更新时间',
						prop: 'updatedAt',
						type: 'datetime',
						format: 'yyyy-MM-dd HH:mm',
						valueFormat: 'yyyy-MM-dd HH:mm:ss',
					},
					{
						label: '更新时间',
						prop: 'updateAts',
						type: 'datetime',
						hide: true,
						searchSpan: 12,
						searchRange: true,
						search: true,
						format: 'yyyy-MM-dd HH:mm',
						valueFormat: 'yyyy-MM-dd HH:mm:ss',
					},
				],
			},
			checkedKeys: [],
			defaultProps: {
				label: 'name',
				value: 'id',
			},
			page: {
				total: 0,
				currentPage: 1,
				pageSize: 20,
				pageSizes: [10, 20, 30, 40, 50, 100, 1000],
				isAsc: false,
			},
			list: [],
			listLoading: true,
			form: {},
			editShowing: false,
			team_place_del: false,
			team_place_edit: false,
			team_place_add: false,
			logDialogVisible: false,
			currentChannel: {},
			batchUpdateFollowModal: false,
			batchUpdateFollowStep: 1,
			batchUpdateFollowResult: {},
			batchUpdateFollowConfirmShow: true,
			batchUpdateFollowLoading: false,
			followFileList: [],
		}
	},
	computed: {
		...mapGetters(['permissions', 'insureTypes']),
		crud() {
			return this.$refs.crud
		},
	},
	// watch: {
	//   role() {
	//     this.form.role = this.role
	//   }
	// },
	watch: {},
	created() {
		this.team_place_add = this.permissions['dist_distChannel_add']
		this.team_place_edit = this.permissions['dist_distChannel_edit']
		this.team_place_del = this.permissions['dist_distChannel_del']
		//控制下载按钮
		//   this.permission.excelBtn = !!this.permissions["dist_distChannel_export"]

		this.option.excelBtn = !!this.permissions['dist_distChannel_export']
	},
	mounted() {
		this.init()
	},
	methods: {
		async init() {
			let res = await customerSourceDic()
			let {code = 0, data = {}} = res.data
			if (code == 0 && data && data.length > 0) {
				if (this.$refs.crud) {
					this.$refs.crud.updateDic('customerSource', data)
				}
			}
			this.getList({
				parentId: 0,
				current: 1,
				size: 20,
			})
			// let {data: {data = [] ,code = -1}} = await getAreaList(2) || {}
			// if (this.validatenull(data) ||  code !== 0) {
			//   return
			// }
			// let businessAreas = this.findObject(this.option.column, 'businessAreas')
			//
			// let tempData = data.map((dataItem) => {
			//   let {areaName,areaCode} = dataItem
			//   return {areaName,areaCode,disabled: false}
			// })
			// tempData.unshift({
			//   areaName: '全国地区',
			//   areaCode: '000000',
			//   disabled: false
			// })
			// businessAreas.dicData = tempData
		},

		getList(page, params = {}) {
			let {insureAuthority = '', insureAuthorityExpire = ''} = params
			if (insureAuthority === 'ALL' && insureAuthorityExpire !== '') {
				//投保状态为全部可用，删掉是否过期筛选
				this.$delete(params, 'insureAuthorityExpire')
			}
			this.listLoading = true
			fetchPlaceList(
				Object.assign(
					{
						// 指定查询主渠道
						parentId: 0,
						current: page.currentPage,
						size: page.pageSize,
						queryType: this.queryType,
					},
					params,
					this.searchForm,
				),
			).then(async ({data: {data = {}}}) => {
				let tempData = data.records
				if (tempData && tempData.length > 0) {
					tempData.forEach((itemData) => {
						let {status, insureTypes = ''} = itemData
						if (status === 0) {
							itemData.insureAuthority = '--'
							itemData.insureTypes = '--'
						} else {
							let tempValues = ''
							//不为停用，展示可用产品
							if (insureTypes === '' || insureTypes === 'ALL') {
								//默认全部
								tempValues = '全合作渠道'
							} else if (insureTypes === 'ALL_VISIBLE') {
								tempValues = '全合作可见渠道'
							} else {
								let insureTypeLists = insureTypes.split(',')
								for (let {name, type} of this.insureTypes) {
									let tempIndex = insureTypeLists.findIndex((itemData) => {
										return type + '' === itemData
									})
									if (tempIndex >= 0) {
										tempValues += name + '<br>'
									}
								}
							}
							itemData.insureTypes = tempValues
						}
					})
				}
				this.page.total = data.total
				this.list = tempData
				this.listLoading = false
				this.formatterCustomerSource()
			})
		},
		//格式化客户来源数据
		async formatterCustomerSource() {
			//格式化客户来源数据
			if (this.list.length > 0) {
				let customerSourceDic = this.$refs.crud.DIC.customerSource
				if (!customerSourceDic) {
					return
				}
				//分组  根据客户来源方式分组
				//1.手动选择HAND
				let handIds = this.list
					.filter((item) => item.customerSourceType == 'HAND')
					.map(({id, customerSourceChannelId = '', customerSource = '', customerSourceChannelType = ''}) => ({
						customerSourceChannelType,
						id,
						customerSourceChannelId,
						customerSource,
					}))
				handIds = handIds.map((item) => {
					let source =
						customerSourceDic[customerSourceDic.findIndex((item2) => item.customerSource == item2.originSource)]
					let {originSourceName = '', crmCustomerSourceChannelList = []} = source

					let crm =
						crmCustomerSourceChannelList[
							crmCustomerSourceChannelList.findIndex((o) =>
								item.customerSourceChannelType == 'customer'
									? o.orginChannelType == 'customer'
									: o.originChannelId == item.customerSourceChannelId,
							)
						]

					let {originChanelLabel} = crm

					let data = {
						...item,
						customerSourceStr1: originSourceName,
						customerSourceStr2: crmCustomerSourceChannelList.length > 0 ? originChanelLabel : '',
					}
					return data
				})

				//2.线索关联CLUE
				let clueIds = this.list
					.filter((item) => item.customerSourceType == 'CLUE')
					.map(({id, customerSourceChannelId = '', customerSource = ''}) => ({
						id,
						customerSourceChannelId,
						customerSource,
					}))
				if (clueIds && clueIds.length > 0) {
					//处理 customer 查询 crm 客户数据 根据 originChannelId（cusID）进行反查 反显
					let res = await searchCustomerClue({
						ids: clueIds.map((item) => item.customerSource),
					})
					let {code = 0, data = {}} = res.data
					if (code == 0 && data && data.length > 0) {
						clueIds = clueIds.map((item) => {
							let clue = data[data.findIndex((o) => o.id == item.customerSource)]
							let {
								nickName = '',
								mobile = '',
								id = '',
								sourceIdLast = '',
								sourceIdText = '',
								customerSourceIdText = '',
								customerSourceChannelIdText = '',
							} = clue
							item.customerSourceStr1 = customerSourceIdText || ''
							item.customerSourceStr2 = customerSourceChannelIdText || ''
							return item
						})
					}
				}
				let data = this.list.map((item) => {
					let hIndex = handIds.findIndex((o) => o.id == item.id)
					let cIndex = clueIds.findIndex((o) => o.id == item.id)
					let customerSourceStr1 =
						hIndex != -1 ? handIds[hIndex].customerSourceStr1 : cIndex != -1 ? clueIds[cIndex].customerSourceStr1 : ''
					let customerSourceStr2 =
						hIndex != -1 ? handIds[hIndex].customerSourceStr2 : cIndex != -1 ? clueIds[cIndex].customerSourceStr2 : ''
					item.customerSourceStr1 = customerSourceStr1
					item.customerSourceStr2 = customerSourceStr2
					return item
				})
				console.log('formatterCustomerSource', clueIds, handIds)

				this.list = data.map((item) => ({
					...item,
					claimsWay: item.claimsWay ? item.claimsWay.split(',') : [],
				}))
				this.$nextTick(() => {
					if (this.$refs.crud) {
						this.$refs.crud.refreshTable()
					}
				})
			}
		},
		searchChange(param, done) {
			this.searchForm = param
			this.page.currentPage = 1
			this.getList(this.page, param)
			done()
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize
		},
		currentChange(current) {
			this.page.currentPage = current
		},
		refreshChange() {
			this.getList(this.page)
		},
		onHandleBeforeOpen(show, type) {
			window.boxType = type
			show()
		},
		handleView(row, index) {
			this.toNewPage('view', row.id)
		},
		handleUpdate(row, index, type) {
			// this.$refs.crud.rowEdit(row, index);
			// this.form.password = undefined;
			this.toNewPage(type, row.id)
		},
		onAddChannel() {
			this.toNewPage('add')
		},
		toNewPage(type, channelId = 0) {
			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					src: '/list/listAdd',
				}),
				query: {
					type,
					channelId,
				},
			})
		},
		create(row, done, loading) {
			if (this.form.phone && this.form.phone.indexOf('*') > 0) {
				this.form.phone = undefined
			}
			// 主渠道使用手机号作为登录名
			this.form.loginName = this.form.loginMobile
			addObj(this.form)
				.then(() => {
					this.getList(this.page)
					done()
					this.$notify.success('创建成功')
				})
				.catch(() => {
					loading()
				})
		},
		update(row, index, done, loading) {
			// if (this.form.phone && this.form.phone.indexOf("*") > 0) {
			//   this.form.phone = undefined;
			// }
			// // 主渠道使用手机号作为登录名
			// this.form.loginName = this.form.loginMobile
			// putObj(this.form)
			//   .then(() => {
			//     this.getList(this.page);
			//     done();
			//     this.$notify.success("修改成功");
			//   })
			//   .catch(() => {
			//     loading();
			//   });
		},
		deletes(row, index) {
			this.$confirm('此操作将永久删除该渠道(渠道名:' + row.name + '), 是否继续？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				delObj(row.id)
					.then(() => {
						this.list.splice(index, 1)
						this.$notify.success('删除成功')
					})
					.catch(() => {
						this.$notify.error('删除失败')
					})
			})
		},
		//停用或者启用
		handleStatus(row) {
			let {status, id, name} = row
			this.$confirm(`此操作将${status === 1 ? '停用' : '启用'} 渠道【${name}】，是否继续？`, '提示', {type: 'warning'})
				.then(() => {
					return putObj({
						status: status === 1 ? 0 : 1,
						id,
					})
				})
				.then(() => {
					this.refreshChange()
					this.$message.success('操作成功!')
				})
		},
		showChannelLog(row) {
			this.currentChannel = row
			this.logDialogVisible = true
		},
		handleLogClose() {
			this.logDialogVisible = false
			this.currentChannel = {}
		},
		//打开批量更新业务跟进人导入框
		openBatchUpdateFollowImport() {
			this.batchUpdateFollowConfirmShow = true
			this.batchUpdateFollowResult = {}
			this.followFileList = []
			this.batchUpdateFollowStep = 1
			this.batchUpdateFollowModal = true
		},
		//上传文件之前
		beforeUploadFollow(file) {
			this.followFileList = [file]
			return false
		},
		//删除文件
		handleFollowRemove(file, fileList) {
			if (file && file.status == 'success') {
				this.followFileList = []
			}
		},
		//下载模板
		downloadFollowTemplate() {
			const link = document.createElement('a')
			link.href = 'https://file.meibaokeji.com/dist/update-channel.xlsx'
			link.download = `批量更新业务跟进人模板-${Date.now()}.xlsx`
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		},
		//批量更新业务跟进人导入确认
		confirmBatchUpdateFollow() {
			// 导入excel
			if (this.batchUpdateFollowStep == 1) {
				const formData = new FormData()
				this.followFileList.forEach((file) => {
					formData.append('file', file)
				})
				this.batchUpdateFollowLoading = true
				batchUpdateFollowImport(formData)
					.then((res) => {
						this.batchUpdateFollowLoading = false
						this.batchUpdateFollowStep = 2
						const resData = res.data.data || {}
						this.batchUpdateFollowResult = resData

						// 根据导入结果调整确认按钮显示
						if (!resData.failCount || resData.failCount === 0) {
							this.batchUpdateFollowConfirmShow = false
						}

						// 根据结果显示不同的提示信息
						if (resData.failCount && resData.failCount > 0) {
							this.$message.warning(`导入完成！成功${resData.successCount}条，失败${resData.failCount}条`)
						} else {
							this.$message.success(`导入成功！共处理${resData.totalRows}条数据`)
						}

						// 刷新列表
						this.refreshChange()
					})
					.catch((e) => {
						this.batchUpdateFollowLoading = false
						this.handleFollowRemove()
						this.$message.error('导入失败!')
					})
			}
			// 下载失败数据
			else if (this.batchUpdateFollowStep == 2) {
				if (this.batchUpdateFollowResult && this.batchUpdateFollowResult.failSrc) {
					window.open(this.batchUpdateFollowResult.failSrc, '_blank')
				}
			}
		},
	},
}
</script>

<style lang="scss">
.user {
	height: 100%;

	&__tree {
		padding-top: 3px;
		padding-right: 20px;
	}
}

.import-main {
	.import-content {
		margin-top: 20px;
		text-align: center;
	}

	.upload-import-text-main {
		margin-top: 10px;
		color: #606266;
	}

	.import-result-title {
		font-size: 18px;
		font-weight: bold;
		color: #303133;
	}

	.import-result-detail {
		text-align: left;

		.result-item {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
			padding: 8px 12px;
			border-radius: 4px;

			&.success {
				border-left: 4px solid #67c23a;
			}

			.result-label {
				font-weight: 500;
				color: #606266;
			}

			.result-value {
				font-weight: bold;
				color: #303133;

				&.error {
					color: #f56c6c;
				}
			}
		}

		.error-messages {
			margin-top: 16px;

			.error-title {
				font-weight: bold;
				color: #f56c6c;
				margin-bottom: 8px;
			}

			.error-list {
				max-height: 200px;
				overflow-y: auto;
				background-color: #fef0f0;
				border: 1px solid #fbc4c4;
				border-radius: 4px;
				padding: 12px;

				.error-item {
					color: #f56c6c;
					margin-bottom: 6px;
					line-height: 1.4;

					&:last-child {
						margin-bottom: 0;
					}
				}
			}
		}
	}
}
</style>
